import React, { useState } from 'react';
import MenuDrawer from './MenuDrawer';
import RfqDetail from '@routes/Common/RfqDetail';

import { DrawingFileManagement, ReceivedQuotationForm } from '@components/Form';

import { MenuStateEnum, MenuTypes } from '../useDrawer';

import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';

import { clsx, colorSet } from '@components/Provider';

import { menuListItems } from './menuListItems';

import {
  CapaQuotationUserRfqDetail,
  CapaQuotationChatRoom,
  CapaQuotationUserVerificationType,
  useFetchMyQuotationUserQuery
} from '@generated/graphql';

import { useSelector } from '@store';
import useDrawer from '../useDrawer';

import { shallowEqual } from 'react-redux';

import { CreatePurchaseOrder, PurchaseOrderView } from '@components/Form';
import { Spotlight, useSpotlight } from '@components/Spotlight';
import { useHistory } from 'react-router-dom';
import { ChevronRight, ChevronUp } from '@carbon/icons-react';
import openViewer from '@utils/popupViewer';
import { VerificationDialog } from '@routes/MyAccount/components/Dialog/RequestActionDialog';

interface Props {
  matches: boolean;
  chatInfo?: CapaQuotationChatRoom;
  rfqDetail?: CapaQuotationUserRfqDetail;
  isDesign: boolean;
}

interface LocationState {
  haveBeenTutorial?: boolean;
  prevInChat?: boolean;
}

const MenuList = ({ matches, rfqDetail, isDesign }: Props) => {
  const [drawer, updateDrawer] = useDrawer();
  const [openNotVerifiedModal, setOpenNotVerifiedModal] = useState<boolean>(
    false
  );
  const { targetRef, width, height } = useSpotlight();
  const history = useHistory();
  const { data: userInfo } = useFetchMyQuotationUserQuery({
    fetchPolicy: 'cache-first'
  });
  const isNotVerifiedUser =
    userInfo?.fetchMyQuotationUser?.data?.verificationType !==
    CapaQuotationUserVerificationType?.Verified;
  const location = history.location;
  const locationState = location.state as LocationState;

  const menuStatus = useSelector(
    (state) => state.chat.menuStatus,
    shallowEqual
  );

  const rfqId = useSelector((state) => state.chat.rfqId ?? undefined);

  const partnerId = useSelector(
    (state) => state.chat.quotationPartnerId ?? undefined
  );

  const chatRoomId = useSelector((state) => state.chat.chatRoomId ?? undefined);

  const chatRoomStatus = useSelector(
    (state) => state.chat.chatRoomStatus ?? undefined
  );

  const hasQuotations = useSelector(
    (state) => state.chat.hasQuotation ?? undefined
  );

  const hasPurchaseOrder = useSelector(
    (state) => state.chat.hasPurchaseOrder ?? undefined
  );
  const { hasProgressingPayment, isOld } = useSelector((state) => state.chat);
  const isTraking = !hasProgressingPayment && !isOld;

  const filteredMenuList = isDesign
    ? menuListItems.filter(
        ({ menu }) => menu !== MenuStateEnum.DrawingFileManagement
      )
    : menuListItems;

  const handleStartTutorial = () => {
    history.push('/capaviewtutorial/1', { chatRoomId });
  };

  const isStartTutorial =
    !locationState?.prevInChat &&
    !locationState?.haveBeenTutorial &&
    !location.search.length &&
    !!targetRef.current;

  return (
    <List disablePadding className="menu-list-root">
      <VerificationDialog
        open={openNotVerifiedModal}
        onClose={() => setOpenNotVerifiedModal(false)}
      />

      {isStartTutorial && (
        <Spotlight
          cutOutTarget={targetRef.current!}
          radiusSize={matches ? 48 : 41}
          CTATitle={
            <Box display={'flex'} alignItems={'center'}>
              {matches ? (
                <>
                  <ChevronUp color={colorSet.primary500} size={26} />
                  도면뷰어를 클릭하세요
                </>
              ) : (
                <>
                  도면뷰어를 클릭하세요
                  <ChevronRight color={colorSet.primary500} size={26} />
                </>
              )}
            </Box>
          }
          CTADescription={
            '도면위를 콕 짚어 주석 남길 수 있는 기능이 추가되었어요.'
          }
          CTADirection={matches ? 'bottom' : 'left'}
          addY={matches ? -30 : 100}
          addX={matches ? 100 : 70}
          handleNextStep={handleStartTutorial}
          clientWidth={width}
          clientHeight={height}
          zIndex={10000}
        />
      )}

      {filteredMenuList.map((menu, index) => (
        <ListItem
          disabled={(() => {
            if (!menuStatus) return true;

            if (menu.menu === 'quotation') {
              return menuStatus?.quotation;
            }

            if (menu.menu === 'purchaseorder') {
              return menuStatus?.purchaseOrder;
            }
          })()}
          key={index}
          button
          className={clsx('menu-item-root', {
            selected: drawer?.menu?.includes(menu.menu),
            isHelper: menu.menu === 'helper'
          })}
          onClick={(e) => {
            const 제조시작 = ['purchaseorder', 'create_purchaseorder'];

            if (menu.menu === 'viewer') {
              return openViewer({
                chatRoomId: chatRoomId,
                rfqId: rfqId
              });
            }

            if (menu.menu === 'helper') {
              return window.open(
                'https://capa.tistory.com/entry/%EC%B9%B4%ED%8C%8C-%EB%B0%9C%EC%A3%BC%EC%84%9C-%EC%84%9C%EB%B9%84%EC%8A%A4%EB%A5%BC-%EC%86%8C%EA%B0%9C%ED%95%A9%EB%8B%88%EB%8B%A4%EA%B3%A0%EA%B0%9D%EC%9A%A9',
                '_blank'
              );
            }

            if (제조시작.includes(menu.menu) && isNotVerifiedUser) {
              setOpenNotVerifiedModal(true);
              return;
            }

            updateDrawer(menu.menu as MenuTypes, isTraking);
          }}
        >
          <ListItemIcon
            className="menu-item-icon"
            ref={menu.menu === MenuStateEnum.Viewer ? targetRef : null}
          >
            <i
              className={
                menu.name === '제조현황'
                  ? 'request-gtm-manufactureCheck-btn'
                  : ''
              }
            >
              {menu.icon}
            </i>
          </ListItemIcon>
          <ListItemText className="menu-item-text">{menu.name}</ListItemText>
        </ListItem>
      ))}

      <MenuDrawer matches={matches}>
        {isDesign && (
          <>
            {drawer.menu === 'request' && (
              <RfqDetail matches={matches} rfqId={rfqId} />
            )}
            {drawer.menu === 'quotation' && (
              <ReceivedQuotationForm
                rfqId={rfqId}
                partnerId={partnerId}
                chatRoomId={chatRoomId}
              />
            )}
            {drawer.menu === 'purchaseorder' && !menuStatus?.purchaseOrder && (
              <PurchaseOrderView
                rfqId={rfqId}
                partnerId={partnerId}
                chatRoomId={chatRoomId}
                hasQuotations={hasQuotations}
                hasPurchaseOrder={hasPurchaseOrder}
              />
            )}

            {drawer.menu === 'create_purchaseorder' &&
              !menuStatus?.purchaseOrder && (
                <CreatePurchaseOrder
                  rfqId={rfqId}
                  partnerId={partnerId}
                  chatRoomId={chatRoomId}
                  chatRoomStatus={chatRoomStatus}
                />
              )}
          </>
        )}
        {!isDesign && (
          <>
            {drawer.menu === 'drawingfile_management' && (
              <DrawingFileManagement matches={matches} rfqId={rfqId} />
            )}

            {drawer.menu === 'request' && (
              <RfqDetail matches={matches} rfqId={rfqId} />
            )}

            {drawer.menu === 'quotation' && (
              <ReceivedQuotationForm
                rfqId={rfqId}
                partnerId={partnerId}
                chatRoomId={chatRoomId}
              />
            )}

            {drawer.menu === 'purchaseorder' && !menuStatus?.purchaseOrder && (
              <PurchaseOrderView
                rfqId={rfqId}
                partnerId={partnerId}
                chatRoomId={chatRoomId}
                hasQuotations={hasQuotations}
                hasPurchaseOrder={hasPurchaseOrder}
              />
            )}

            {drawer.menu === 'create_purchaseorder' &&
              !menuStatus?.purchaseOrder && (
                <CreatePurchaseOrder
                  rfqId={rfqId}
                  partnerId={partnerId}
                  chatRoomId={chatRoomId}
                  chatRoomStatus={chatRoomStatus}
                />
              )}
          </>
        )}
      </MenuDrawer>
    </List>
  );
};

export default MenuList;
